var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.429 1.821a.609.609 0 0 0-.607.607v12.143a.609.609 0 0 0 .607.607h8.5v-3.035a1.213 1.213 0 0 1 1.214-1.214h3.036v-8.5a.609.609 0 0 0-.607-.607ZM10.929 17h-8.5A2.431 2.431 0 0 1 0 14.571V2.429A2.431 2.431 0 0 1 2.429 0h12.142A2.431 2.431 0 0 1 17 2.429v8.709a2.429 2.429 0 0 1-.71 1.719l-3.434 3.433a2.429 2.429 0 0 1-1.719.71Z"
  })));
};
export default SvgDocument;